import React from "react";

const PluralizedUpToLabel = (users: number) => ((users === 1)
  ? RESX.SoUser.UpTo1User
  : RESX.SoUser.UpToNrUsers.replace("{0}", users.toString()));

const UpToInternalUsers = ({ upTo, inUse }: { upTo: number, inUse?: number }) => {
  if (!inUse) {
    return <span>{PluralizedUpToLabel(upTo)}</span>;
  }

  const unUsed = upTo - inUse;

  if (unUsed === 0) {
    return <>{PluralizedUpToLabel(upTo)}<div className="s1_gray">{RESX.Subscription.AllInUse}</div></>;
  }

  return <>{PluralizedUpToLabel(upTo)}<div className="s1_gray">{`${RESX.Subscription.XInUse.replace("{0}", inUse.toString())} / ${RESX.Subscription.XUnused.replace("{0}", unUsed.toString())}`}</div></>;
};

export default UpToInternalUsers;
